import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEquifaxIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 48,
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 48,
		height: 48,
		rx: 8,
		fill: "#981E32"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M35.0713 17.5799L36 13H16.7229L14.1686 25.5946L12 35.7368H31.8195L32.8258 30.9117H21.8329L22.8393 26.0035H32.1291L33.1354 21.4236H23.8456L24.6199 17.5799H35.0713Z",
		fill: "white"
	})]
});
export default SvgEquifaxIcon;
